import { render } from "./ChevronUpDownSvg.vue?vue&type=template&id=c12bb91e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__